import api from "@modules/api/api";
import { keepPreviousData, useQuery } from "@tanstack/react-query";
import consumerFinancingQueryKeys from "../consumerFinancingQueryKeys";
import {
  ConsumerFinancing,
  ConsumerFinancingNotFoundResponse,
} from "../types/ConsumerFinancing";

const getActiveConsumerFinancing = () => {
  return api.get<ConsumerFinancing | ConsumerFinancingNotFoundResponse>(
    "api/purchases/c2c-financing/active-consumer-financing"
  );
};

export const checkActiveConsumerFinancing = (
  consumerFinancing:
    | ConsumerFinancing
    | ConsumerFinancingNotFoundResponse
    | undefined
) => {
  const purchaseNotFoundResponse =
    consumerFinancing as ConsumerFinancingNotFoundResponse;
  const activePurchase = consumerFinancing as ConsumerFinancing;

  return (
    !!(activePurchase && activePurchase.id) || purchaseNotFoundResponse?.exists
  );
};

export default function useConsumerFinancing() {
  const {
    data: consumerFinancing,
    isLoading,
    error,
    isFetching,
    isStale,
    refetch,
  } = useQuery({
    queryKey: consumerFinancingQueryKeys.consumerFinancing(),
    queryFn: () => getActiveConsumerFinancing(),
    placeholderData: keepPreviousData,
    meta: { overrideDefaultErrorHandling: true },
  });

  return {
    consumerFinancing,
    isLoading,
    error,
    isFetching,
    isStale,
    refetch,
  };
}
